var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClubs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.473 39.062c-5.394 0-10.389 2.297-13.885 5.993-1.499 1.599-4.096 3.497-6.893 4.995 1.399-4.995 5.394-11.288 8.291-14.085 3.696-3.596 5.894-8.491 5.894-14.085 0-10.69-8.49-19.28-18.98-19.38-10.489.1-18.98 8.69-18.98 19.38 0 5.494 2.198 10.489 5.894 14.085 2.897 2.697 6.993 8.99 8.291 14.085-2.797-1.598-5.294-3.496-6.893-4.995-3.496-3.696-8.39-5.993-13.885-5.993-10.389 0-18.98 8.69-18.98 19.38 0 10.788 8.591 19.379 19.18 19.379 5.494 0 10.389-2.298 13.885-6.094 1.599-1.598 4.296-3.696 7.293-5.394-.381 12.942-6.292 22.712-12.638 27.062a2.222 2.222 0 0 0-.948 1.84 2.265 2.265 0 0 0 2.265 2.265h31.132a2.265 2.265 0 0 0 2.265-2.265c0-.732-.345-1.426-.948-1.84-6.346-4.35-12.252-14.124-12.538-27.162 2.897 1.698 5.694 3.796 7.293 5.394 3.496 3.696 8.391 6.094 13.885 6.094 10.589 0 19.18-8.691 19.18-19.38 0-10.589-8.491-19.28-19.18-19.28z",
    fill: "#000000",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubs);
export default __webpack_public_path__ + "static/media/clubs.3e5ecbbf8a04c6c58e8b1e7320782458.svg";
export { ForwardRef as ReactComponent };